import { api } from "./client";
import { Team } from "@/types";

export const teamService = {
  getAll: async () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response: any = await api.get("teams");
    return response.responseBody.data as Team[];
  },

  create: async (data: Partial<Team>) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response: any = await api.post("teams", data);
    return response.responseBody.data as Team;
  },

  update: async (id: string, data: Partial<Team>) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response: any = await api.put(`teams/${id}`, data);
    return response.responseBody.data as Team;
  },

  delete: async (id: string) => {
    await api.delete(`teams/${id}`);
  },
};
